import { c as _c } from "react/compiler-runtime";
import { useDraw } from './useDraw.js';
import { useGetDrawResult } from './useGetDrawResult.js';
/**
 * Gets the current status of a draw.
 *
 * @param drawNumber - The draw number identifier
 * @param product - The draw product definition
 * @returns The current draw status ('TemporaryClosed', 'Cancelled', or client status)
 */
export function useDrawStatus(drawNumber, product) {
  const $ = _c(6);
  let t0;
  if ($[0] !== drawNumber || $[1] !== product) {
    t0 = {
      product,
      drawNumber
    };
    $[0] = drawNumber;
    $[1] = product;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const draw = useDraw(t0);
  let t1;
  if ($[3] !== drawNumber || $[4] !== product) {
    t1 = {
      product,
      drawNumber
    };
    $[3] = drawNumber;
    $[4] = product;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const drawResult = useGetDrawResult(t1);
  const {
    client
  } = draw.data.draw.drawState;
  let isCancelled = false;
  if (drawResult.data.type !== "NONE") {
    isCancelled = drawResult.data.data.isCancelled;
  }
  const isTemporaryClosed = draw.data.draw.regBetDisabled !== "NotDisabled";
  let status;
  if (isTemporaryClosed) {
    status = "TemporaryClosed";
  } else {
    if (isCancelled) {
      status = "Cancelled";
    } else {
      status = client;
    }
  }
  return status;
}